import files from "../files/index";
var path = '/v2';
var v2 = function (url) { return function () { return ({
    files: files(url + path)
}); }; };
export default v2;
